import { SymbolType, ReelStrip } from '../types/game.types';

export const DEFAULT_REEL_STRIPS: ReelStrip[] = [
    {
        symbols: [
            SymbolType.ACE, SymbolType.KING, SymbolType.SCATTER, SymbolType.QUEEN,
            SymbolType.JACK, SymbolType.TEN, SymbolType.DICE, SymbolType.MARTINI,
            SymbolType.WILD, SymbolType.COINS, SymbolType.HORSESHOE, SymbolType.ACE,
            SymbolType.KING, SymbolType.QUEEN, SymbolType.SPORTS_CAR, SymbolType.JACK,
            SymbolType.TEN, SymbolType.SHOWGIRL_HAT, SymbolType.ACE, SymbolType.KING,
            SymbolType.QUEEN, SymbolType.JACK, SymbolType.NEON_DIAMOND, SymbolType.TEN,
            SymbolType.DICE, SymbolType.MARTINI, SymbolType.COINS, SymbolType.TREASURE_CHEST,
            SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.KING, SymbolType.QUEEN
        ]
    },
    {
        symbols: [
            SymbolType.KING, SymbolType.QUEEN, SymbolType.JACK, SymbolType.TEN,
            SymbolType.WILD, SymbolType.DICE, SymbolType.MARTINI, SymbolType.COINS,
            SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.SCATTER, SymbolType.KING,
            SymbolType.QUEEN, SymbolType.JACK, SymbolType.TEN, SymbolType.SPORTS_CAR,
            SymbolType.DICE, SymbolType.SHOWGIRL_HAT, SymbolType.MARTINI, SymbolType.COINS,
            SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.KING, SymbolType.NEON_DIAMOND,
            SymbolType.QUEEN, SymbolType.JACK, SymbolType.TEN, SymbolType.DICE,
            SymbolType.TREASURE_CHEST, SymbolType.MARTINI, SymbolType.COINS, SymbolType.HORSESHOE
        ]
    },
    {
        symbols: [
            SymbolType.QUEEN, SymbolType.JACK, SymbolType.TEN, SymbolType.DICE,
            SymbolType.MARTINI, SymbolType.COINS, SymbolType.WILD, SymbolType.HORSESHOE,
            SymbolType.ACE, SymbolType.KING, SymbolType.QUEEN, SymbolType.JACK,
            SymbolType.SCATTER, SymbolType.TEN, SymbolType.DICE, SymbolType.SPORTS_CAR,
            SymbolType.MARTINI, SymbolType.COINS, SymbolType.HORSESHOE, SymbolType.SHOWGIRL_HAT,
            SymbolType.ACE, SymbolType.KING, SymbolType.QUEEN, SymbolType.JACK,
            SymbolType.TEN, SymbolType.NEON_DIAMOND, SymbolType.DICE, SymbolType.MARTINI,
            SymbolType.COINS, SymbolType.TREASURE_CHEST, SymbolType.HORSESHOE, SymbolType.ACE
        ]
    },
    {
        symbols: [
            SymbolType.JACK, SymbolType.TEN, SymbolType.DICE, SymbolType.MARTINI,
            SymbolType.COINS, SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.KING,
            SymbolType.QUEEN, SymbolType.WILD, SymbolType.JACK, SymbolType.TEN,
            SymbolType.DICE, SymbolType.SCATTER, SymbolType.MARTINI, SymbolType.COINS,
            SymbolType.SPORTS_CAR, SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.KING,
            SymbolType.SHOWGIRL_HAT, SymbolType.QUEEN, SymbolType.JACK, SymbolType.TEN,
            SymbolType.DICE, SymbolType.MARTINI, SymbolType.NEON_DIAMOND, SymbolType.COINS,
            SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.TREASURE_CHEST, SymbolType.KING
        ]
    },
    {
        symbols: [
            SymbolType.TEN, SymbolType.DICE, SymbolType.MARTINI, SymbolType.COINS,
            SymbolType.HORSESHOE, SymbolType.ACE, SymbolType.KING, SymbolType.QUEEN,
            SymbolType.JACK, SymbolType.TEN, SymbolType.WILD, SymbolType.DICE,
            SymbolType.MARTINI, SymbolType.COINS, SymbolType.HORSESHOE, SymbolType.SCATTER,
            SymbolType.ACE, SymbolType.KING, SymbolType.SPORTS_CAR, SymbolType.QUEEN,
            SymbolType.JACK, SymbolType.TEN, SymbolType.SHOWGIRL_HAT, SymbolType.DICE,
            SymbolType.MARTINI, SymbolType.COINS, SymbolType.HORSESHOE, SymbolType.NEON_DIAMOND,
            SymbolType.ACE, SymbolType.KING, SymbolType.QUEEN, SymbolType.TREASURE_CHEST
        ]
    }
];